import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "empty-state text-center text-secondary py-5" }
const _hoisted_2 = { class: "mt-3 mb-1" }
const _hoisted_3 = {
  key: 0,
  class: "mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: _normalizeClass(['bi', $props.icon, 'empty-icon'])
    }, null, 2),
    _createElementVNode("h5", _hoisted_2, _toDisplayString($props.title), 1),
    ($props.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.message), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}